<template>
  <div class="image-container">
    <img
      src="/images/longoka_solo.webp"
      alt="logo du site"
      style="width: 50%"
    />
  </div>
</template>

<style scoped>
.image-container {
  display: flex;
  justify-content: left;
  align-items: center;
}
</style>
